import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './core/core.module';
import { WordListComponent } from '@home/components/navigation-sidebar/word-list/word-list.component';

@NgModule({
  declarations: [AppComponent],
  imports: [BrowserModule, AppRoutingModule, CoreModule.forRoot(), BrowserAnimationsModule, HttpClientModule],
  providers: [WordListComponent],
  bootstrap: [AppComponent],
})
export class AppModule { }
